import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";

const StyledSelect = styled(Select)({
    fontSize: "14px",
    padding: "9px 6px 9px 6px",
    boxSizing: "border-box",
    height: "37px",
    width: "100%",
    "&:focus": {
        backgroundColor: "transparent",
        borderBottom: "none",
    },
    "&::before": {
        borderBottom: "none !important",
    },
    "&::after": {
        borderBottom: "none !important",
    },
});

const AdminDocumentTypeList = (props) => {
    const {
        documentTypesForParentEntity,
        mediaAssetKey,
        optionalDocs,
        parentEntityTypeKey,
        preexistingValue,
        requiredDocs,
        savedDocuments,
        style,
        updateDocumentFromAdminList,
        documentRequirements,
        documentAttachmentPermissions,
    } = props;

    const [selectedValue, setSelectedValue] = useState("Select");

    const allowedFileTypesImg = ["png", "jpeg", "jpg"];
    const docTypesAndAllowedFiles = {
        "Primary Photo": allowedFileTypesImg,
        Photo: allowedFileTypesImg,
        "Marketing Flyer Photo": allowedFileTypesImg,
    };

    useEffect(() => {
        if (preexistingValue["documentType"]) {
            setSelectedValue(preexistingValue["documentType"]["name"]);
        } else {
            setSelectedValue("Select");
        }
    }, [preexistingValue]);

    const updateSelectedValue = () => {
        if (preexistingValue["documentType"]) {
            if (preexistingValue["documentType"]["name"] !== selectedValue) {
                setSelectedValue(preexistingValue["documentType"]["name"]);
            }
        } else if (selectedValue !== "Select") {
            setSelectedValue("Select");
        }
    };

    const handleValueSelect = (e) => {
        documentTypesForParentEntity.forEach((documentTypeObject) => {
            if (e.target.value.toLowerCase() === documentTypeObject.name.toLowerCase()) {
                updateDocumentFromAdminList(
                    mediaAssetKey,
                    parentEntityTypeKey,
                    documentTypeObject.documentTypeKey,
                    documentTypeObject
                );
                setSelectedValue(e.target.value);
                return;
            }
        });
        setSelectedValue(e.target.value);
    };

    const shouldAllowMoreDocumentsOfSameType = (documentType) => {
        const documentNames = Object.values(savedDocuments).map((mediaAsset) =>
            mediaAsset.documentType ? mediaAsset.documentType.name.toLowerCase() : null
        );
        return documentType.multipleAllowed || !documentNames.includes(documentType.name.toLowerCase());
    };

    const isFormDisabled = () => {
        const documentTypeKey = preexistingValue?.documentType?.documentTypeKey;
        if (!documentTypeKey) return false;

        const documentRequirement = documentRequirements?.find(
            (requirement) => requirement.documentTypeKey === documentTypeKey
        );

        const documentAttachmentPermission = documentAttachmentPermissions?.find(
            (permission) => permission.documentTypeKey === documentTypeKey
        );

        return !documentRequirement?.canUpload || !documentAttachmentPermission?.canDelete;
    };

    const renderMenuItem = (documentType, index) => {
        const shouldShow =
            documentType &&
            documentType.canUpload &&
            documentType.actionType !== "DOCUMENT_HIDE" &&
            shouldAllowMoreDocumentsOfSameType(documentType);

        const disableMenuItem =
            Object.keys(docTypesAndAllowedFiles).includes(documentType.name) &&
            !docTypesAndAllowedFiles[documentType.name].includes(
                preexistingValue?.mediaAssetName?.split(".").pop().toLowerCase()
            );

        return shouldShow ? (
            <MenuItem key={index} value={documentType.name} disabled={disableMenuItem}>
                {documentType.name}
            </MenuItem>
        ) : (
            <MenuItem key={index} value={documentType.name} style={{ display: "none" }}>
                {documentType.name}
            </MenuItem>
        );
    };

    updateSelectedValue();
    return (
        <StyledSelect
            name="document-admin-dropdown"
            value={selectedValue}
            onChange={(e) => handleValueSelect(e)}
            style={style}
            disabled={isFormDisabled()}
        >
            <MenuItem value="Select" disabled>
                Select
            </MenuItem>
            <MenuItem value="" disabled>
                Required
            </MenuItem>
            {requiredDocs.map((documentReq, indexReq) => {
                return renderMenuItem(documentReq, indexReq);
            })}

            <MenuItem value="" disabled>
                Optional
            </MenuItem>
            {optionalDocs.map((documentOpt, indexOpt) => {
                return renderMenuItem(documentOpt, indexOpt);
            })}
        </StyledSelect>
    );
};

export default AdminDocumentTypeList;
